import { useEffect, Component } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import CustomCursor from "./components/CustomCursor";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Stats from "./components/Stats";
import Products from "./components/Products";
import Grades from "./components/Grades";
import Calculator from "./components/Calculator";
import Industries from "./components/Industries";
import WhyUs from "./components/WhyUs";
import Certifications from "./components/Certifications";
import Credentials from "./components/Credentials";
import Clients from "./components/Clients";
import About from "./components/About";
import FAQ from "./components/FAQ";
import SeoContent from "./components/SeoContent";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ThreadDivider from "./components/ThreadDivider";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white font-mono text-sm text-slate-600 p-10">
          Something went wrong — please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, duration: 1.2 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      if (href.length > 1 && document.querySelector(href)) {
        e.preventDefault();
        lenis.scrollTo(href, { offset: -72 });
      } else {
        e.preventDefault();
        lenis.scrollTo(0);
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="bg-white text-[#0A1128] font-sans antialiased">
        <CustomCursor />
        <Toaster position="bottom-right" richColors />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Stats />
          <ThreadDivider label="THREAD ROLLING · CNC MACHINING" />
          <Products />
          <Grades />
          <Industries />
          <Calculator />
          <WhyUs />
          <ThreadDivider label="MILL TEST CERTIFIED · BATCH TRACEABLE" />
          <Certifications />
          <Credentials />
          <Clients />
          <About />
          <FAQ />
          <Contact />
          <SeoContent />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </ErrorBoundary>
  );
}

export default App;
